(function() {
    'use strict';

    angular.module('settings')
        .controller('MessagesCreateController', MessagesCreateController);

    MessagesCreateController.$inject = ['$q', '$state', 'contactDataService', 'notificationSrvc', 'messagesMessagesConst', 'competenceDataSrvc', 'contactSrvc', 'adminDataSrvc', 'orderDataSrvc', 'clientDataSrvc', 'searchFilterSrvc', 'checkModelPermissionsSrvc', 'messagesPermissionsConst', 'errorNotificationSrvc'];

    function MessagesCreateController($q, $state, contactDataService, notificationSrvc, messagesMessagesConst, competenceDataSrvc, contactSrvc, adminDataSrvc, orderDataSrvc, clientDataSrvc, searchFilterSrvc, checkModelPermissionsSrvc, messagesPermissionsConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            responsible_person: [],
            client: [],
            competency: [],
            complaint_reason: [],
            order: [],
            order_product: [],
            message_content: []
        };

        self.clientContactData = {
            responsible_person: '',
            client: '',
            competency: '',
            complaint_reason: '',
            order: '',
            order_product: '',
            message_content: ''
        };

        self.messageData = {
            files: []
        };

        self.admins = [];
        self.clients = [];
        self.competences = [];
        self.competencesReclamationReason = [];
        self.clientOrders = [];
        self.clientOrderProducts = [];

        self.createClientContact = createClientContact;
        self.cleanErrors = cleanErrors;

        self.onClientSearch = onClientSearch;
        self.onClientChange = onClientChange;
        self.onClientOrderChange = onClientOrderChange;
        self.isNotReclamation = isNotReclamation;

        self.hasPermissionAddMessage = hasPermissionAddMessage;

        activate();

        function activate() {
            getAdmins();
            getClients();
            getCompetences();
            getCompetencesReclamationReason();
        }

        function createClientContact() {
            contactDataService.create(
                self.clientContactData
            ).$promise.then(
                function(response) {
                    contactSrvc.addMessageFiles(response.conversation_messages[0], self.messageData.files)
                        .then(function(response_files) {
                            notificationSrvc.notification("success", messagesMessagesConst.add);
                            $state.go('layout.messages.list');
                        });
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function getAdmins() {
            return adminDataSrvc.clientContact().$promise.then(
                function(response) {
                    self.admins = response;
                    return response;
                }
            );
        }

        function getClients() {
            return clientDataSrvc.clientContactClients().$promise.then(
                function(response) {
                    self.clients = response.results;
                    return response;
                }
            );
        }

        function onClientSearch(params) {
            if (!params) {
                params = {};
            }
            return clientDataSrvc.clientContactClients(
                params
            ).$promise;
        }

        function onClientChange() {
            getClientOrders(self.clientContactData.client);
            self.cleanErrors('client');
        }

        function getCompetences() {
            return competenceDataSrvc.clientContactList({
                complaint_reason: searchFilterSrvc.getCheckboxFilterValue(false)
            }).$promise.then(
                function(response) {
                    self.competences = response;
                    return response;
                }
            );
        }

        function getCompetencesReclamationReason() {
            return competenceDataSrvc.clientContactList({
                complaint_reason: searchFilterSrvc.getCheckboxFilterValue(true)
            }).$promise.then(
                function(response) {
                    self.competencesReclamationReason = response;
                    return response;
                }
            );
        }

        function getClientOrders(client_pk) {
            return orderDataSrvc.clientContact({
                client_pk: client_pk
            }).$promise.then(
                function(response) {
                    self.clientOrders = response;
                    return response;
                }
            );
        }

        function onClientOrderChange() {
            getClientOrderProducts(self.clientContactData.order);
            self.cleanErrors('order');
        }

        function getClientOrderProducts(order_pk) {
            var order = self.clientOrders.find(function(item) {
                return item.pk === order_pk;
            });

            if (order) {
                self.clientOrderProducts = order.order_products;
            } else {
                self.clientOrderProducts = [];
            }
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

        function isNotReclamation() {
            var competency = self.competences.find(function(item) {
                return item.pk === self.clientContactData.competency;
            });
            return !(competency && competency.reclamation) || !competency;
        }

        function hasPermissionAddMessage() {
            return !checkModelPermissionsSrvc.isDenied(
                messagesPermissionsConst.add);
        }
    }
})();
